import { render, staticRenderFns } from "./TicketScaleDataInfoCard.vue?vue&type=template&id=a8b7e64c&"
import script from "./TicketScaleDataInfoCard.vue?vue&type=script&lang=js&"
export * from "./TicketScaleDataInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports